import { status } from './../../models/Checkinstatus';
import { ExcelService } from './../../service/excelDownload/excel.service';
import { UntypedFormBuilder } from '@angular/forms';
import { Utils } from './../../common/utils';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Component, OnInit } from "@angular/core";
import Swal from 'sweetalert2';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: "app-superadmin-physician-payout",
  templateUrl: "./superadmin-physician-payout.component.html",
  styleUrls: ["./superadmin-physician-payout.component.css"],
})
export class SuperadminPhysicianPayoutComponent implements OnInit {
  public physicianPayout;
  public selectedTransactions: any;
  allTransactions: any;
  transactions: any;
  transactionStatus = Utils.PAYOUT_STATUS;
  noTransactions: boolean = true;
  constructor(
    private spinner: NgxSpinnerService,
    private payoutService: VproService,
    ) {}


    showToast(type, title) {
      Toast.fire({
        type: type,
        title:
          title
      });
    }

  ngOnInit(): void {
    this.getPhysicianPayout();
  }

  getPhysicianPayout(){
    this.spinner.show();
    this.payoutService.fetchPhysicianTransfers().subscribe((data)=>{
      this.spinner.hide();
      console.log('data',data);
      this.transactions = data;
      if (this.transactions && this.transactions.length) {
        // Map transacion status from Constants
        this.transactions = this.transactions.map((t) => {
          t.status = t.status == 'on_hold' ? this.transactionStatus.ON_HOLD : t.status == 'processed' ? this.transactionStatus.PROCESSED : t.status == 'in-progress' ? this.transactionStatus['IN_PROGRESS'] : t.status == 'failed' ? this.transactionStatus['FAILED'] : this.transactionStatus['N/A'];
          return t;
        });
        this.allTransactions = this.transactions;
        this.noTransactions = false;

        this.transactions.forEach((aptime) => {
          if (aptime) aptime.aptime = Utils.formatTime(aptime.aptime);
        });
      } else {
        this.noTransactions = true;
      }
    },(error)=>{
      this.spinner.hide();
      let message;
      if (
        error &&
        error.error &&
        error.error.message &&
        error.error.message.message
      ) {
        message = error.error.message.message;
      } else message = "Something went wrong. Couldn't get transactions.";
      this.showToast('error', message);
    })
  }
  payout(){
    console.log(this.selectedTransactions);
    if(this.selectedTransactions && this.selectedTransactions.length > 0){
      let mappedData = this.selectedTransactions.map((trans)=>{
        return {
          transfer_id : trans.transfer_id,
          aptid: trans.aptid
        }
      })
      console.log('mappedData',mappedData);

      this.spinner.show();
      this.payoutService.processPhysicianPayout({transactions: mappedData}).subscribe((data)=>{
        this.spinner.hide();
        this.getPhysicianPayout();
      },(error)=>{
        this.spinner.hide();
        let message;
        if (
          error &&
          error.error &&
          error.error.message &&
          error.error.message.message
        ) {
          message = error.error.message.message;
        } else message = "Something went wrong. Couldn't update Transactions.";
        this.showToast('error', message);
      })
    }
  }

  filterPayout(){

  }
  markSelected() {
    this.selectedTransactions = this.allTransactions.filter((value, index) => {
      return value.isChecked;
    });
  }


}
